module.exports = __webpack_public_path__ + "static/media/arts_11.8925cc7c.jpg";